import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { ReviewCta } from './ReviewCta';

export const ReadingNext = ({ id, to, title, copy, ctaTestId }) => (
  <aside className="reading-next" data-testid={`${id}-next`}>
    <Link to={to} data-testid={`${id}-continue`} className="reading-next-link">
      <span className="reading-next-label">Continue the thread</span>
      <span className="reading-next-title">{title}<ArrowUpRight size={22} aria-hidden="true" /></span>
      <span className="reading-next-copy">{copy}</span>
    </Link>
    <ReviewCta location={`${id}-next`} testId={ctaTestId || `${id}-scope-review`} />
  </aside>
);